import AltLayout from 'Nori/Layout/AltLayout';
import RichText from 'Custom/RichText';
import FAQWrapper from 'Custom/FAQ/FAQWrapper';
import FinderSimple from 'Custom/Finder/FinderSimple';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import HeroFull from 'Nori/Hero/HeroFull';
import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/half-pink-marble-mobile.png';
import styles from 'styles/pages/questions.module.scss';
import { SPANISH_JOB_CODE } from 'Custom/Footer/es/Footer.utils';
import {
  FAQ_EXPLORING_QUESTIONS,
  FAQ_NEXPLANON_USERS,
} from 'Utils/es/questions';

const HEAD = {
  title:
    'Preguntas frecuentes sobre NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  keywords: 'preguntas sobre nexplanon',
  description:
    'Revise las preguntas y respuestas frecuentes sobre NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, incluidas las preguntas sobre la inserción de NEXPLANON y cómo funciona.',
  hreflang: 'es-us',
};

export default function QuestionsSpanish() {
  
  const HeroBannerContent = () => (
    <div className={styles['content-wrap']} data-qa-tag="content-wrap-faq">
      <RichText data-qa-tag="richtext-faq-section">
        <div
          className={styles.pregnancyAfterNexplanonPage}
          data-qa-tag="faq-page-wrapper"
        >
          <h4 data-qa-tag="heading-faq">Preguntas frecuentes</h4>

          <div
            className={styles.middleHeroText}
            data-qa-tag="faq-middle-hero-text"
          >
            Las preguntas más frecuentes sobre Nexplanon
          </div>

          <p
            className={styles.bottomHeroText}
            data-qa-tag="faq-bottom-hero-text"
          >
            y, por supuesto, las respuestas a esas preguntas.
          </p>
        </div>
      </RichText>
    </div>
  );

  return (
    <AltLayout head={HEAD} jobCode={SPANISH_JOB_CODE}>
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper-faq">
        <ItemBreakpoint
          breakpoint={'lg'}
          data-qa-tag="item-breakpoint-faq-hero"
        >
          <HeroFull
            image={HERO_BG_IMAGE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="NEXPLANON: FAQS"
            data-design-module_no="01"
            data-qa-tag="hero-full-desktop-faq"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-desktop-faq" />
          </HeroFull>

          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="NEXPLANON: FAQS"
            data-design-module_no="01"
            data-qa-tag="hero-full-mobile-faq"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-mobile-faq" />
          </HeroFull>
        </ItemBreakpoint>
      </div>

      <FAQWrapper
        data-qa-tag="faq-wrapper-exploring"
        className={styles.firstAccordion}
        title={'Acerca de NEXPLANON'}
        questions={FAQ_EXPLORING_QUESTIONS}
        moduleNumber="02"
      />

      <FAQWrapper
        data-qa-tag="faq-wrapper-usage"
        title={'Uso de NEXPLANON'}
        questions={FAQ_NEXPLANON_USERS}
        moduleNumber="03"
        className={styles.secondAccordion}
        whiteColoredborder={true}
      />

      <FinderSimple
        data-qa-tag="finder-simple-nexplanon"
        designModuleNo="04"
        title="Lista PARA NEXPLANON"
        buttonLabel="Encuentra un médico"
        buttonHref="/what-is-nexplanon/#find-a-doctor"
      >
        Encuentra un profesional de la salud capacitado e inicia la conversación.
      </FinderSimple>
    </AltLayout>
  );
}
